// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.button-container {
    display: flex;
    flex-direction: row;
    gap: 5px
}

.multiSelectContainer {
    width: 300px
}


.env-info-container {
    background-color: #C7C7C7;
    border: 1px;
    border-radius: 5px;
}

.non-editable{
   pointer-events: none;
   background-color: grey;
}`, "",{"version":3,"sources":["webpack://./src/components/OnboardingForm.css"],"names":[],"mappings":";;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;GACG,oBAAoB;GACpB,sBAAsB;AACzB","sourcesContent":["\n\n\n.button-container {\n    display: flex;\n    flex-direction: row;\n    gap: 5px\n}\n\n.multiSelectContainer {\n    width: 300px\n}\n\n\n.env-info-container {\n    background-color: #C7C7C7;\n    border: 1px;\n    border-radius: 5px;\n}\n\n.non-editable{\n   pointer-events: none;\n   background-color: grey;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
